import { useEffect } from 'react';

import { toast } from 'react-toastify';
import { TextButton } from '../components/generic/TextButton';
import configAPIJSON from '../configAPI.json';
import { interactionHooks } from './interactionHooks';
import { keyboardCoreHooks } from './keyboardCoreHooks';
import { mouseCoreHooks } from './mouseCoreHooks';
import { sceneHooks } from './sceneHooks';
import { uiHooks } from './uiHooks';
import { useEditor } from './useEditor';
import { useScene } from './useScene';
import { userHooks } from './userHooks';
const configAPI = JSON.parse(JSON.stringify(configAPIJSON));
const ENDPOINTS = configAPI.endpoints;

//* This component is isolated to avoid unnecessary re-renders of the whole app

export const Hooks = () => {
  const scene = useScene();
  const { userSession, launcherThemeSession, userLogin } = useEditor();

  mouseCoreHooks();
  keyboardCoreHooks();

  uiHooks();
  interactionHooks();
  userHooks();
  sceneHooks();

  useEffect(() => {
    const isLoggedIn = userSession.isLoggedIn;
    const isAuthorized = userSession.isAuthorized;
    const themeID = launcherThemeSession.themeID;
    if (isLoggedIn === null) return;

    toast.dismiss();

    if (isLoggedIn) {
      if (themeID) {
        if (!isAuthorized) {
          toast.error('Unauthorized access to the theme!', {
            autoClose: false,
            closeOnClick: false,
            draggable: false,
          });
          toast.warn(
            <span>
              You need to open a theme using the PatchKit panel
              <br />
              Your current work <b>will not be saved!</b>
              <br />
              <br />
              <a href={ENDPOINTS.themesPage}>
                Click here to go to the PatchKit panel
              </a>
            </span>,
            {
              autoClose: false,
              closeOnClick: false,
              draggable: false,
            }
          );
        }
      } else {
        toast.warn(
          <span>
            You need to open a theme using the PatchKit panel
            <br />
            Your current work <b>will not be saved!</b>
            <br />
            <br />
            <a href={ENDPOINTS.themesPage}>
              Click here to go to the PatchKit panel
            </a>
          </span>,
          {
            autoClose: false,
            closeOnClick: false,
            draggable: false,
          }
        );
      }
    } else {
      if (themeID) {
        toast.warn(
          <span>
            You need to log in
            <br />
            Do it in the popup window or go to the Panel
            <br />
            <br />
            <a href={ENDPOINTS.themesPage}>
              Click here to go to the PatchKit panel
            </a>
          </span>,
          {
            autoClose: false,
            closeOnClick: false,
            draggable: false,
          }
        );
        userLogin();
      } else {
        toast.info(
          <span>
            This is DEMO mode - your changes <b>will not be saved!</b>
            <br />
            Create a theme on the PatchKit panel to start your work
            <br />
            <br />
            <a href={ENDPOINTS.themesPage}>
              Click here to go to the PatchKit panel
            </a>
          </span>,
          {
            autoClose: false,
            closeOnClick: false,
            draggable: false,
          }
        );
      }
    }
  }, [userSession.isLoggedIn]);

  // Restore unsaved theme
  useEffect(() => {
    const isLoggedIn = userSession.isLoggedIn;
    if (isLoggedIn === null) return;
    const themeID = launcherThemeSession.themeID;

    const lastHistoryStateJSON = localStorage.getItem('lastHistoryStateJSON');
    const restoredHistoryState =
      lastHistoryStateJSON && JSON.parse(lastHistoryStateJSON);
    const restoredThemeID = restoredHistoryState?.themeID;
    const restoredLauncherConfig = restoredHistoryState?.launcherConfigJSON;

    if (isLoggedIn) {
      if (themeID) {
        if (restoredThemeID === themeID) {
          toast.warn(
            <span>
              There is an unsaved version of your theme
              <br />
              <br />
              <TextButton
                handleClick={() => {
                  scene.importLauncherConfigJSON(restoredLauncherConfig);
                }}
              >
                Click here to restore it
              </TextButton>
            </span>,
            {
              autoClose: false,
              closeOnClick: true,
              draggable: false,
            }
          );
        }
      }
    }
  }, [launcherThemeSession.isThemeLoaded]);

  return <></>;
};
